// Campus photo for /colleges/tulane-university: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ATulane_University_-_Gibson_Hall_from_St._Charles_Avenue%2C_February_2026.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/tulane-university/; credited under the photo.
const photo = {
    "slug": "tulane-university",
    "alt": "Gibson Hall, a Romanesque stone building behind live oaks and a lawn at Tulane University",
    "src": "/colleges/tulane-university/campus-1600.webp",
    "srcSmall": "/colleges/tulane-university/campus-800.webp",
    "srcMid": "/colleges/tulane-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/tulane-university/og.jpg",
    "title": "Tulane University - Gibson Hall from St. Charles Avenue, February 2026",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ATulane_University_-_Gibson_Hall_from_St._Charles_Avenue%2C_February_2026.jpg",
    "read": "2026-10-02"
};

export default photo;
